import {DataSource} from 'Shared/utilities/DataSourceUtility';

export type AccountSourceType = 'ORDINARY' | 'GROUP';

export const getAccountDetailsQueryParams = (source: string, groupNumber?: string, productCode?: string) => {
  const isEIS = Number(source) === DataSource.EIS;
  if (isEIS) {
    const groupNbrQueryString = groupNumber ? `&groupNbr=${groupNumber}` : '';
    const productCdQueryString = productCode ? `&productCd=${productCode}` : '';
    return `?source=${source}${groupNbrQueryString}${productCdQueryString}`;
  }
  return `?source=${source}`;
};

export const INVOICE_LINK_PREFIX = 'gpart://Invoice/Invoicing//';

export default {
  ACCOUNTS: '/agent/accounts',
  ACCOUNTS_API: (version: string) => `/api/employer/v${version}/accounts/get`,
  ACCOUNT_DETAILS_API: (version: string) => `/api/employer/v${version}/accounts/accountNumber/details/get`,
  ACCOUNTS_BY_ACCOUNT_NUMBER: (accountNumber?: string) => `/agent/accounts?accountNumber=${accountNumber}`,
  ACCOUNTS_BY_GROUP_NUMBER: (groupAccountNumber?: string) => `/agent/accounts?groupNumber=${groupAccountNumber}`,
  ACCOUNTS_BY_NAME: (accountName: string) => `/agent/accounts?accountName=${accountName}`,
  ACCOUNTS_BY_NUMBER: (accountNumber: string) => `/agent/accounts?accountNumber=${accountNumber}`,
  ACCOUNT_DETAILS: (accountId: string, accountNumber: string, source: string, groupNbr?: string, productCd?: string) =>
    `/agent/accounts/${accountId}/accountNumber/${accountNumber}${getAccountDetailsQueryParams(
      source,
      groupNbr,
      productCd
    )}`,
  ACCOUNT_DISCREPANCIES: (accountNumber: string, accountId: string) =>
    `/agent/accounts/${accountNumber}/discrepancies/${accountId}`,
  ACCOUNT_DISCREPANCY_SUMMARIES: (accountId: string, accountNumber: string, sourceId: string, paymentDate: string) =>
    `/agent/accounts/${accountId}/discrepancySummaries?accountNumber=${accountNumber}&sourceId=${sourceId}&paymentDate=${paymentDate}`,
  POLICY_INFORMATION_REPORTS: '/agent/accounts/reports/policyInformationReport',
  INVOICE_DISCREPANCIES: (accountNumber: string, invoiceLink: string) => {
    const {invoiceId, revision, uuid} = getInvoiceParams(invoiceLink);
    return `/agent/accounts/${accountNumber}/invoice/${invoiceId}/${revision}/${uuid}`;
  },
};

const getInvoiceParams = (invoiceLink: string) => {
  const invoiceLinkParams = invoiceLink.split('//')[2]?.split('/');
  return {
    invoiceId: invoiceLinkParams[0],
    revision: invoiceLinkParams[1],
    uuid: invoiceLinkParams[3],
  };
};
